<template>
  <TButtonGroup>
    <TGroupButton
      data="underline"
      tooltip="Underline"
      small
      toggle
      :active="isUnderlineActive"
      :inverse="inverse"
      @button-clicked="toggleUnderline"
    >
      <font-awesome-icon :icon="['fas', 'underline']" />
    </TGroupButton>
  </TButtonGroup>
</template>

<script setup lang="ts">
import { expandSelectionToWord, getActiveMarks } from "../_internal/cutomExtensions";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
import { Editor } from "@tiptap/core";
import { computed } from "vue";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

const isUnderlineActive = computed(() => {
  if (!props.editor) return false;

  // Check stored marks first (for empty paragraphs)
  const marks = getActiveMarks(props.editor);
  const hasUnderlineMark = marks.some((mark) => mark.type.name === "underline");
  if (hasUnderlineMark) return true;

  // Fallback to editor.isActive
  return props.editor.isActive("underline");
});

function toggleUnderline() {
  if (!props.editor) return;
  expandSelectionToWord(props.editor);
  props.editor.chain().focus().toggleUnderline().run();
}
</script>
